module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-BOOSTER-GREEN-1.eb302f0d.jpg";